module.exports = __webpack_public_path__ + "img/by_institution.4133818b.png";